module.exports = __webpack_public_path__ + "img/极客数据团队-下层.caf39d1f.png";